import React from 'react';
import { Modal, BodyText, Button, HeadingText } from '@paypalcorp/pp-react';
import { StyleSheet, css } from 'aphrodite';
import PropTypes from 'prop-types';
import { Row, Col } from '@paypalcorp/pp-react';

const styles = StyleSheet.create({
  modalContent: {
    maxWidth: 600,
    margin: '0 auto',
  },
  okButton: {
    marginTop: 36,
  },
  msgMargin: {
    marginTop: '24px',
  },
});

export default function DonateGiftAidHowItWorksOverlay(props) {
  const { content } = props;

  return (
    <Modal
      className="giftaid-howitworks-overpanel"
      overpanel
      title=""
      isOpen={props.isOpen}
      onClose={props.closeOverlay}
      hideLogo
      closeOnBackgroundClick={true}
    >
      <div className="modal-body" id="giftaiditModal">
        <div className="">
          <div className={`${css(styles.modalContent)} modal-content`}>
            <Row>
              <Col className="text-center">
                <HeadingText size="lg">{content.howitworks}</HeadingText>
              </Col>
            </Row>
            <Row>
              <Col>
                <BodyText className={css(styles.msgMargin)}>
                  {content.modalp1}
                </BodyText>
              </Col>
            </Row>
            <Row>
              <Col>
                <BodyText className={css(styles.msgMargin)}>
                  {content.modalp2}
                </BodyText>
              </Col>
            </Row>
            <Row>
              <Col>
                <BodyText className={css(styles.msgMargin)}>
                  {content.modalp3}
                </BodyText>
              </Col>
            </Row>
            <Row>
              <Col>
                <BodyText className={css(styles.msgMargin)}>
                  {content.modalp4}
                </BodyText>
              </Col>
            </Row>

            <Row>
              <Col>
                <div className={`${css(styles.okButton)} text-center`}>
                  <Button className="btn-wide" onClick={props.closeOverlay}>
                    {content.ok}
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </Modal>
  );
}

DonateGiftAidHowItWorksOverlay.propTypes = {
  content: PropTypes.object,
  isOpen: PropTypes.bool,
  closeOverlay: PropTypes.func,
};
